import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../components/Navigation/Navigation';
import { ComparisonSection } from '../../../shared/components';
import flagImage from '../../../shared/assets/images/flag.png';
import './PricingPage.css';

const PricingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="pricing-page">
      <Navigation />
      
      {/* Hero Section */}
      <div className="pricing-hero-section">
        <div className="container">
          <div className="pricing-hero-content">
            <h1>Simple, Transparent Pricing</h1>
            <p>Designed for small businesses. Always free to start, simple to scale.</p>
          </div>
        </div>
      </div>

      {/* Pricing Plans Section */}
      <div className="pricing-plans-section">
        <div className="container">
          <div className="pricing-grid single-plan">
            
            {/* Early Adopter Plan */}
            <div className="pricing-card early-adopter">
              <div className="pricing-header">
                <h3>Early Adopter</h3>
                <div className="price">
                  <span className="currency">$</span>
                  <span className="amount">0</span>
                  <span className="period">/month</span>
                </div>
                <p className="plan-description">Join our early adopter program and get full access for free!</p>
              </div>
              <div className="pricing-features">
                <div className="user-range early-adopter-badge">
                  <strong>🚀 For the first 100 businesses that sign up</strong>
                </div>
                <ul>
                  <li>✓ Complete loyalty program</li>
                  <li>✓ NFC pod included & installed</li>
                  <li>✓ Full custom branding</li>
                  <li>✓ Customer data collection</li>
                  <li>✓ Advanced analytics</li>
                  <li>✓ Email marketing tools</li>
                  <li>✓ Priority support</li>
                  <li>✓ All features included</li>
                </ul>
              </div>
            </div>

          </div>
          
          {/* Single CTA below all plans */}
          <div className="pricing-cta">
            <Link to="/businesssignup" className="pricing-btn btn-primary">Get Started Today</Link>
            <p className="cta-note">Join our early adopter program - completely free while we're in beta</p>
          </div>
        </div>
      </div>

      {/* Comparison Section */}
      <ComparisonSection />
      
      {/* Footer */}
      <footer className="page-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Bounce Loyalty</h3>
              <p>The world's easiest loyalty program.</p>
            </div>
            <div className="footer-section">
              <h4>Product</h4>
              <ul>
                <li><Link to="/#features">Features</Link></li>
                <li><Link to="/#how-it-works">How it Works</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Company</h4>
              <ul>
                <li><a href="mailto:jakob.solstrozberg@torontomu.ca">Contact</a></li>
                <li><Link to="/about">About Us</Link></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Get Started</h4>
              <ul>
                <li><Link to="/businesssignup">Sign Up</Link></li>
                <li><Link to="/businesssignin">Sign In</Link></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="proudly-canadian">
              <img src={flagImage} alt="Canadian Flag" className="canadian-flag" />
              <span>Proudly Canadian</span>
            </div>
            <p>&copy; 2025 Bounce Loyalty. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PricingPage;
